export const BRAND = {
  name: "U-NEXX DEVELOPMENT GROUP INC.",
  short: "U-NEXX",
  tagline: "Building Today. Developing Tomorrow. Delivering Value.",
  mission:
    "To simplify and optimize property investment and development by delivering transparent, efficient, and high-quality end-to-end services.",
  vision:
    "To become a trusted global partner in real estate development and property investment solutions.",
  email: "info@unexxdevelopmentgroup.com",
  phone: "+1 (780) 246-6195",
  address: "Edmonton, Alberta, Canada",
  founded: "Established 2019",
  markets: "Canada · Caribbean",
};

export const NAV_LINKS = [
  { to: "/", label: "Home", testId: "nav-home" },
  { to: "/about", label: "About", testId: "nav-about" },
  { to: "/services", label: "Services", testId: "nav-services" },
  { to: "/projects", label: "Projects", testId: "nav-projects" },
  { to: "/invest", label: "Invest", testId: "nav-invest" },
  { href: "mailto:info@unexxdevelopmentgroup.com", label: "Contact", testId: "nav-contact", external: true },
];

export const IMAGES = {
  hero: "https://static.prod-images.emergentagent.com/jobs/3e3ed7a2-2d57-423a-856c-5c54dbf72b44/images/8a217486b4350f368068859a84868a439b728c0541b37f6df77850bf1ab0fa5b.png",
  texture: "https://static.prod-images.emergentagent.com/jobs/3e3ed7a2-2d57-423a-856c-5c54dbf72b44/images/84c30f8c2579074a3bf13b073411cde314e13c900947af10c802a870db6d9735.png",
  luxury: "https://static.prod-images.emergentagent.com/jobs/3e3ed7a2-2d57-423a-856c-5c54dbf72b44/images/d6787cb69998f2570d5187df90ed080634902d3421df4b9002d97f840aadd67b.png",
  skyline: "https://images.unsplash.com/photo-1617336422396-e1dfc4210ec5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHxlZG1vbnRvbiUyMGFsYmVydGElMjBza3lsaW5lJTIwbmlnaHR8ZW58MHx8fHwxNzgwMzY5Nzk0fDA&ixlib=rb-4.1.0&q=85",
  exterior1: "https://images.pexels.com/photos/26838218/pexels-photo-26838218.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  exterior2: "https://images.unsplash.com/photo-1768223933860-6d62bc5b2ff3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBsdXh1cnklMjBhcmNoaXRlY3R1cmUlMjBleHRlcmlvciUyMGJ1aWxkaW5nfGVufDB8fHx8MTc4MDM2OTc5NHww&ixlib=rb-4.1.0&q=85",
  project1: "https://images.pexels.com/photos/30506378/pexels-photo-30506378.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  // Caribbean / St Lucia villa imagery
  stlucia: "https://images.unsplash.com/photo-1613490493576-7fde63acd811?auto=format&fit=crop&w=1600&q=80",
  villaHero: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1600&q=80",
  villaPool: "https://images.unsplash.com/photo-1582719508461-905c673771fd?auto=format&fit=crop&w=1600&q=80",
  caribbeanCoast: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=1600&q=80",
};
